import { render, staticRenderFns } from "./SessionColumn.vue?vue&type=template&id=b18ed7c4&scoped=true&"
import script from "./SessionColumn.vue?vue&type=script&lang=js&"
export * from "./SessionColumn.vue?vue&type=script&lang=js&"
import style0 from "./SessionColumn.vue?vue&type=style&index=0&id=b18ed7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18ed7c4",
  null
  
)

export default component.exports